exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/cds-labs.js-WebpackMultiOutput";